module.exports = __webpack_public_path__ + "img/ccf-zh-TW.634fa6ec.png";